const breakpointsMaps = {
	1: 600,
	2: 960,
	3: 1280,
	4: 1920,
};

const Breakpoints = {
	sm: 1,
	md: 2,
	lg: 3,
	xl: 4,
};

function mq(breakpoint) {
	return `@media(max-width: ${breakpointsMaps[breakpoint]}px)`;
}

export { Breakpoints, mq };
